import { useLayoutEffect } from 'react';

export const HardRefresh = () => {
  useLayoutEffect(() => {
    window.location.reload();
  }, []);
  return null;
};
